import type { ThemeConfig } from "antd";
import { ConfigProvider, Layout } from "antd";
import Authenticated from "./navigation/Authenticated";
import UnAuthenticated from "./navigation/UnAuthenticated";
import useAuthStore from "@Store/authStore";

const config: ThemeConfig = {
  token: {
    colorPrimary: "#1F3D2B",
    colorSuccess: "#28a745",
    colorWarning: "#ffcc00",
    colorError: "#ff4d4f",
  },
};

const Navigator = () => {
  const { isAuth } = useAuthStore();
  return (
    <ConfigProvider theme={config}>
      <Layout className="">
        {isAuth ? <Authenticated /> : <UnAuthenticated />}
      </Layout>
    </ConfigProvider>
  );
};
export default Navigator;
